<div class="row">
  <div class="col">
    <div class="wccard p-2 mb-1">
        <div class="d-flex justify-content-between align-items-center">
            <div>
              <!-- (click)="goToDetailsPage()" -->
              <div class="f-14 font-weight-600 mb-1">{{projectDetails?.projectname | titlecase}}</div>
                <div class="progress-container mb-1" *ngIf="aiSourcingStatus !== 'completed'">
                  <div>
                    <span class="status-btn live-status">
                      <i class="fa-solid" [ngClass]="progress === 100 ? 'fa-circle-check' : 'fa-spinner'"></i>
                      {{ progress === 100 ? 'Loaded Results' : 'Generating Results'}} {{progress}}%
                    </span>
                  </div>
                </div>
              <div class="text-9696 f-12"><i class="fa-solid fa-briefcase mr-1"></i>{{projectDetails?.jobtitles[0]
                |
                titlecase}}, <span *ngIf="projectDetails?.jobtitles?.length > 1"
                  matTooltip="{{chipCleanUp(projectDetails?.jobtitles?.slice(1)?.toString())}}"
                  [matTooltipClass]="{ 'red-tooltip': true }">+{{projectDetails?.jobtitles?.length - 1}}</span>
                  <i class="fa-sharp fa-solid fa-pipe mx-1"></i><span><i
                    class="fa-solid fa-location-dot mr-1"></i>
                    <span *ngIf="projectDetails?.locations?.length > 0">
                      {{chipCleanUp(projectDetails?.locations[0]) | titlecase}}
                      <span *ngIf="projectDetails?.locations?.length > 1"
                        matTooltip="{{chipCleanUp(projectDetails?.locations?.slice(1))}}"
                        [matTooltipClass]="{ 'red-tooltip': true }">+{{projectDetails?.locations?.length - 1}}</span>
                    </span>
                    <span *ngIf="!projectDetails?.locations?.length">{{projectDetails?.location | titlecase}}</span>
                    <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit" class="mr-1">|</span> <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit">Distance: {{projectDetails?.distance}} {{projectDetails?.distanceunit}}</span></span>
              </div>
            </div>

          <!-- <span class="f-14 blue-text pointer" (click)="redirectToReview()"  *ngIf="aiSourcingStatus == 'completed'"style="border: 1px solid #2E93A1; padding: 7px;">Review Candidates</span> -->
            <div class="d-flex align-items-center">
              <div class="toggle-container mr-1" *ngIf="aiSourcingStatus == 'completed'">
                  <span class="inactivebtn" (click)="redirectToReview()">Candidates</span>
                  <span class="activebtn">Project Insights</span>
                </div>

                <span class="dropdown ats-dropBtn px-2 mr-1 ml-3">
                <button data-testid="auto-app-ai-sourcing-insights-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                  appDropdownToggle aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="userDropdownButton" >
                  <a data-testid="auto-app-ai-sourcing-insights-a-1" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('project-details')"
                   ><i class="fa-light fa-file-lines mr-2"></i> Project Details</a>
                  <a data-testid="auto-app-ai-sourcing-insights-a-2" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('autopilot-criteria')">
                   <i class="fa-solid fa-sparkles mr-2"></i> Autopilot Criteria
                  </a>
                  <a data-testid="auto-app-ai-sourcing-insights-a-3" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('autopilot-activity')">
                    <i class="fa-light fa-clock-rotate-left mr-2"></i> Activity
                  </a>
                </div>
              </span>
              </div>
          </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="projectDetails?.aisourcingstatus != 'completed'">
  <div class="col">
    <div class="ideal-talen-card d-flex d-inline align-items-center">
      <img src="../../../assets/ai-sourcing/webbtree_sidebar.svg" style="width: 8%;" alt="">
      <div class="ml-2">
        <p class="f-16 font-weight-600 ">Webbtree Autopilot<sup><span>AI</span></sup> is sourcing your talent</p>
        <p class="f-14 font-weight-400">You’ll get an email when results are ready. Meanwhile explore Talent Pool
          Insights.</p>
      </div>

    </div>
  </div>
</div>

<div class="wccard d-flex flex-column mb-1 px-2" style="padding-top: 8px ;padding-bottom:8px;">
  <app-ai-sourcing-insights-ai [totalcount]="totalCandidatesCount" [insightsaidata]="insightsData"
    [events]="insightsSubject.asObservable()"></app-ai-sourcing-insights-ai>

</div>
<div class="row" *ngIf="projectDetails">
  <div class="col">
    <div class="wccard d-flex justify-content-between mb-1 px-2 py-2 talentCountFixonScroll" style="gap: 10px;">
      <div class="d-flex align-items-center four-matrix" style="cursor: default;">
        <div *ngIf="!totalCandidatesCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
        </div>
        <div class="talent-data-card" *ngIf="totalCandidatesCountAvailable">
          <span class="f-18 font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
          <p class="text-9696 f-12 mb-0">Talent Count</p>
        </div>
      </div>
      <div class="d-flex align-items-center four-matrix" style="cursor: default;">
        <div *ngIf="!medianTenureInCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="median tenure">
        </div>
        <div class="talent-data-card" *ngIf="medianTenureInCountAvailable">
          <span class="f-18 font-weight-600" [innerHTML]="getFormattedTenureForMatrix(totalMedianTanureCount)"></span>
          <p class="text-9696 f-12 mb-0">Median Tenure <i class="fas fa-info-circle"
              matTooltip='Median Tenure of the talent' [matTooltipClass]="{ 'big-tooltip text-black': true }"></i></p>
        </div>
      </div>

      <!-- <div class="d-flex align-items-center align-items-center diversity-matrix">
        <div *ngIf="!genderDataAvailable" class="text-center" style="margin-top: 6px;">
          <img src="../../assets/rolling-loader.gif" style="width: 16%;" alt="">
        </div>
        <div class="talent-data-card">
          <div class="d-flex justify-content-center" style="width: 100%; height:100%" *ngIf="genderDataAvailable">
            <div class="gender-ratio pl-1">
              <div class="gender">
                <i class="fas fa-male text-9696 f-20"></i>
                <span class="f-26 font-weight-600 pl-2 pr-1">{{malePercent}}</span>
                <span class="f-18 font-weight-500">%</span>
              </div>
              <p class="f-12 text-9696 text-center mb-0">Men</p>
            </div>
            <div class="male-box text-9696 pt-2 mx-1"> | </div>
            <div class="gender-ratio pr-1">
              <div class="gender">
                <i class="fas fa-female text-9696 f-20"></i>
                <span class="f-26 font-weight-600 female-box pl-2 pr-1">{{femalePercent}}</span>
                <span class="f-18 font-weight-500">%</span>
              </div>
              <p class="f-12 text-9696 text-center mb-0">Women</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="!changedJobsCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="changedJobs">
        </div>
        <div class="talent-data-card" *ngIf="changedJobsCountAvailable">
          <span class="f-18 font-weight-600">{{formatNumberToIndianFormat(changedJobs)}}</span>
          <p class="text-9696 f-12 mb-0">Changed Jobs(past 1yr)</p>
        </div>
      </div>
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="hasJobDemand" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="Active Jobs Posts">
        </div>
        <div  class="talent-data-card" *ngIf="!hasJobDemand">
          <p class="f-18 font-weight-600 mb-0">
            <span *ngIf="jobDemandCount && jobDemandCount != 0 && jobDemandCount != '0'">{{jobDemandCount}}</span>
             <span *ngIf="!jobDemandCount" style="font-family: Arial, sans-serif;">&mdash;</span>
          </p>
          <p class="f-12 text-9696 mb-0">Active Job Posts</p>
        </div>
      </div>
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="hasJobDemand" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="Salary Range">
        </div>
        <div  class="talent-data-card" *ngIf="!hasJobDemand">
          <p class="f-18 font-weight-600 mb-0">
            <span *ngIf="medianSalary" [innerHTML]="medianSalary"></span>
            <span *ngIf="!medianSalary" style="font-family: Arial, sans-serif;">&mdash;</span>
          </p>
          <p class="f-12 text-9696 mb-0">Salary Range</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <app-person-search-insights *ngIf="projectDetails" (insightsEvents)="insightsEventHandler($event)"
      [projectnumber]="projectnumber" [aiSourcingContinent] ="projectDetails?.continent"></app-person-search-insights>
  </div>
</div>

<ng-template #holdingTemplate class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-8 pt-8">
      <div class="text-center">
        <img src="../../../assets/images/webbtree-logo.gif" style="width: 9%;" alt="" class="mb-6">
        <p class="f-24 font-weight-600 mb-2"><span class="" style="color: #C845AB;">Webbtree Autopilot<sup style="top: -4px!important;"><span>AI</span></sup></span> is finding your ideal
          talent</p>
        <p class="mb-2">Searching, ranking and delivering top outreach-ready talent from 630M+ Global profiles</p>
        <p class="mb-6">You’ll be notified via email once results are ready. In the meantime,<br>
          review your Talent Pool Insights to identify potential opportunities.</p>
        <button data-testid="auto-app-ai-sourcing-insights-button-2" class="btn-trms-regular dismiss-btn" (click)="dismiss()"> Got it</button>
      </div>
    </div>
  </div>

</ng-template>

<!-- <ng-template #holdingTemplate class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="font-weight-600">
            Search History
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div>


    </div>
  </div>
</ng-template> -->
